import type { SVGProps } from 'react';
import { chakra, keyframes } from '@chakra-ui/react';

const G = chakra('g');

const float = keyframes`
0% {
  transform: translateY(0%);
}
50% {
  transform: translateY(20%);
}
100% {
  transform: translateY(0%);
}
`;
const floatAnimation = `${float} infinite 2s linear`;

export const InsertCardIllustration = (props: SVGProps<SVGSVGElement>) => (
  <svg width={207} height={315} fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <mask
      id='a'
      style={{
        maskType: 'alpha',
      }}
      maskUnits='userSpaceOnUse'
      x={0}
      y={0}
      width={207}
      height={315}>
      <path
        d='M103.5 315c57.161 0 103.5-46.562 103.5-104V0H0v211c0 57.438 46.339 104 103.5 104Z'
        fill='#006D86'
      />
    </mask>
    <g mask='url(#a)'>
      <path
        d='M19.686 227.357C21.01 217.421 29.486 210 39.51 210h127.98c10.024 0 18.499 7.421 19.824 17.357l10.667 80C199.58 319.346 190.252 330 178.156 330H28.844c-12.096 0-21.424-10.654-19.825-22.643l10.667-80Z'
        fill='#006D86'
      />
      <ellipse cx={102.5} cy={226} rx={66.5} ry={25} fill='url(#b)' />
      <path
        d='M27.302 231.075v119.92c8.838 1.117 41.364 3.35 76.198 3.35 34.833 0 67.359-2.233 76.198-3.35v-119.92c0-9.211-7.536-17.802-17.026-16.747-10.048 1.116-26.237 9.21-59.172 9.21-32.936 0-49.124-8.094-59.172-9.21-9.49-1.055-17.026 7.536-17.026 16.747Z'
        fill='url(#c)'
      />
      <path
        d='M44.328 223.817c10.048 3.35 26.237 9.211 59.172 9.211s49.124-5.861 59.172-9.211'
        stroke='#006D86'
      />
      <circle cx={142.715} cy={252.066} r={6} fill='#D8601E' />
      <circle cx={160.715} cy={252.066} r={6} fill='#006D86' />
      <G filter='url(#d)' animation={floatAnimation}>
        <g clipPath='url(#e)'>
          <rect x={50} y={2} width={107} height={177} rx={8} fill='#C8E3E6' />
          <rect
            x={94.62}
            y={164.305}
            width={22.1}
            height={17.76}
            rx={3.25}
            transform='rotate(-90 94.62 164.305)'
            fill='#fff'
            stroke='#fff'
            strokeWidth={1.5}
          />
          <path
            d='M106.128 161.027h6.894v-1.5h-6.894v1.5Zm4-9.704h2.894v-1.5h-2.894v1.5Zm-3.25 8.954V155.4h-1.5v4.877h1.5Zm0-4.877v-.827h-1.5v.827h1.5Zm-.75.75h7.002v-1.5h-7.002v1.5Zm-12.258 4.877H100v-1.5H93.87v1.5Zm6.879-.75V155.4h-1.5v4.877h1.5Zm-.75-5.627H93.87v1.5H100v-1.5Zm.75.75v-4.827h-1.5v4.827h1.5Zm0-4.827v-4.341h-1.5v4.341h1.5Zm-.75-.75H93.87v1.5H100v-1.5Zm-6.129-2.841H100v-1.5H93.87v1.5Zm6.129 0h3.064v-1.5h-3.064v1.5Zm3.064 0h9.959v-1.5h-9.959v1.5Zm.75-.75v-4.777h-1.5v4.777h1.5Zm-3.814 14.795h3.064v-1.5h-3.064v1.5Zm3.064 0h3.065v-1.5h-3.065v1.5Zm-.75-.75v4.778h1.5v-4.778h-1.5Zm7.815-10.454a4.75 4.75 0 0 0-4.75 4.75h1.5a3.25 3.25 0 0 1 3.25-3.25v-1.5Z'
            fill='#83B1B6'
          />
          <circle opacity={0.45} cx={160} cy={15} r={53} fill='#82C5CB' />
          <g clipPath='url(#f)'>
            <path
              d='m149.594 56.514-3.131-7.918-17.708-19.615 17.348-.649c.461-3.922 1.515-10.535 7.209-14.095 5.102-3.19 15.841-3.284 22.38-3.81 11.071-.891 27.487-2.159 34.311-2.681 3.723 12.64 3.638 42.517-2.239 51.696l-28.956-1.179 5.76 3.057c4.956 2.588 4.697 11.363-.524 13.011l-17.104 3.546-2.696-9.709 4.871-1.207-15.363-6.295a7.622 7.622 0 0 1-4.158-4.152Z'
              fill='#D8601E'
            />
            <path
              d='m128.691 28.946 17.327-.65 6.891 10.673-6.533 9.573-17.685-19.596Z'
              fill='#DDA98C'
            />
            <path
              d='m146.246 26.646-2.395 1.738 9.029 10.548 3.924-3.1-10.558-9.186ZM156.482 43.225l-3.569-4.29-8.585 6.935 1.842 2.1 10.312-4.745Z'
              fill='#A43900'
            />
            <path
              d='M133.452 55.13c-5.103-.382-14.084-.928-17.937-1.153-10.602-.65-12.631-6.69-12.758-12.596-.127-5.904 4.702-12.048 12.646-12.072l4.533-.127c-1.913-1.196-.891-4.65 1.79-4.745 2.681-.095 6.323 2.114 4.872 4.558l6.662-.187c9.175-.016 15.142 5.694 14.959 13.676-.184 7.983-8.389 13.122-14.767 12.645Z'
              fill='#DDA98C'
            />
            <path
              d='M130.548 53.623c-1.582.416-3.277.893-3.956 1.041 3.853.225 6.86.465 6.86.465 6.378.476 14.583-4.662 14.766-12.645.184-7.982-5.783-13.693-14.958-13.677l-6.662.188-9.551.302.068 2.336 11.788-.12c2.351-.202 4.982 1.642 5.116 4.232.133 2.591.225 10.505.215 13.312.067 2.337-1.708 4.045-3.686 4.566Z'
              fill='#014558'
            />
            <path
              d='m124.205 45.275 6.076 2.367a.544.544 0 0 0 .688-.27l1.775-3.695'
              stroke='#014558'
              strokeWidth={0.5}
            />
            <path
              d='M120.478 46.079a1.558 1.558 0 1 0 .074 3.116M120.491 40.003a1.558 1.558 0 1 0 .074 3.116'
              stroke='#014558'
              strokeWidth={0.75}
            />
            <path
              d='M138.303 40.228c.319 1.327-.152 2.856.729 3.048.88.191 2.489-1.805 2.033-3.71-.456-1.905-2.672-3.056-3.492-2.386-.698.57.407 1.709.73 3.048Z'
              fill='#fff'
            />
            <path d='m152.977 38.977 58.997 2.423' stroke='#6E2600' strokeWidth={0.5} />
          </g>
          <path
            stroke='#006D86'
            d='M130.942 164.566V80.245M62.401 164.566v-33.071M62.401 126.672V93.6M62.401 88.088V55.017M62.401 49.505V16.433M139.515 164.566v-55.455'
          />
        </g>
      </G>
      <path
        d='M27.302 231.075v119.92c8.838 1.117 41.364 3.35 76.198 3.35 34.833 0 67.359-2.233 76.198-3.35v-119.92c0-9.211-7.536-17.802-17.026-16.747-10.048 1.116-26.237 9.21-59.172 9.21-32.936 0-49.124-8.094-59.172-9.21-9.49-1.055-17.026 7.536-17.026 16.747Z'
        fill='url(#g)'
      />
      <path
        d='M44.328 223.817c10.048 3.35 26.237 9.211 59.172 9.211s49.124-5.861 59.172-9.211'
        stroke='#006D86'
      />
      <circle cx={142.714} cy={252.066} r={6} fill='#D8601E' />
      <circle cx={160.714} cy={252.066} r={6} fill='#006D86' />
    </g>
    <path
      d='M17.5 147v26.5m0 0L26 165m-8.5 8.5L9 165M190.5 150v26.5m0 0 8.5-8.5m-8.5 8.5L182 168'
      stroke='#fff'
      strokeWidth={4}
      strokeLinecap='round'
    />
    <defs>
      <linearGradient
        id='c'
        x1={103.5}
        y1={255.5}
        x2={103.5}
        y2={316}
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#6BC4D2' />
        <stop offset={1} stopColor='#22A0B5' />
      </linearGradient>
      <linearGradient
        id='g'
        x1={103.5}
        y1={255.5}
        x2={103.5}
        y2={316}
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#6BC4D2' />
        <stop offset={1} stopColor='#22A0B5' />
      </linearGradient>
      <clipPath id='e'>
        <rect
          x={50}
          y={179}
          width={177}
          height={107}
          rx={8}
          transform='rotate(-90 50 179)'
          fill='#fff'
        />
      </clipPath>
      <clipPath id='f'>
        <rect
          x={94.014}
          y={70.369}
          width={63.051}
          height={62.986}
          rx={4}
          transform='rotate(-90 94.014 70.37)'
          fill='#fff'
        />
      </clipPath>
      <radialGradient
        id='b'
        cx={0}
        cy={0}
        r={1}
        gradientUnits='userSpaceOnUse'
        gradientTransform='matrix(0 -22.5 78.0085 0 102.5 229.5)'>
        <stop stopColor='#014558' />
        <stop offset={1} stopColor='#006D86' />
      </radialGradient>
      <filter
        id='d'
        x={50}
        y={2}
        width={107}
        height={179}
        filterUnits='userSpaceOnUse'
        colorInterpolationFilters='sRGB'>
        <feFlood floodOpacity={0} result='BackgroundImageFix' />
        <feColorMatrix
          in='SourceAlpha'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          result='hardAlpha'
        />
        <feOffset dy={2} />
        <feComposite in2='hardAlpha' operator='out' />
        <feColorMatrix values='0 0 0 0 0.0923611 0 0 0 0 0.534155 0 0 0 0 0.633333 0 0 0 1 0' />
        <feBlend in2='BackgroundImageFix' result='effect1_dropShadow_3_12' />
        <feBlend in='SourceGraphic' in2='effect1_dropShadow_3_12' result='shape' />
      </filter>
    </defs>
  </svg>
);
